export enum STEP_PAGES {
  ELIGIBILITY = "eligibility",
  RIAMSIGNIN = "riamSignIn"
}

export enum PRODUCT_DETAILS {
  CCPA = "ccpa",
  OBDA = "obda2.0"
}

export enum CARD_TYPES {
  AIB = "AIB",
  CPX = "CPX",
  MC6 = "MC6",
  CLX = "CLX"
}
